import Codification from "./Codification.component";

export default Codification;
